import React, { useState } from "react";
import { Button, Row, Col } from "@mtm/components";
import { Form, Input } from "antd";
import "antd/dist/antd.css";
import { isEmailValid } from "../../helpers/ValidationHelpers";
import { ReCaptcha } from "../ReCaptcha/ReCaptcha";
import {
  IZipData,
  RegistrationComponentLoad,
  TrackAnalytics,
} from "../../types/ApplicationTypes";
import { checkIsRegisteredEmail } from "../../services/RegistrationService";
import NiceToMeetYou from "../../assets/images/NiceToMeetYou.png";
import CheckMark_Blue from "../../assets/images/CheckMark_Blue.svg";
import Styles from "./Email.module.scss";
import { backArrowIcon } from "../../assets/images";
import MTMAccountExistsModal from "../../helpers/MTMAccountExistsModal";

type Props = {
  setPageType: Function;
  setEmailId: Function;
  zipData: IZipData;
  setWandaEmailId: Function;
};

const Email: React.FC<Props> = ({ setPageType, setEmailId, zipData, setWandaEmailId }) => {
  const [email, setEmail] = useState<string>("");
  const [isValidEmail, setIsValidEmail] = useState<boolean>(true);
  const [btnClick, setBtnClick] = useState<boolean>(false);
  const [isIDPExists, setIsIDPExists] = useState<boolean>(false);

  const [form] = Form.useForm();

  function handleEmailChange(e: any) {
    setEmail(e.target.value);
    if (email.length > 0) {
      setIsValidEmail(true);
    }
  }

  async function handleEmail(execute: () => Promise<string>) {
    if (isEmailValid(email)) {
      TrackAnalytics(
        "/Registration",
        "Valid Email - Continue Button Clicked",
        "Valid Email"
      );

      setBtnClick(true);
      setIsValidEmail(true);
      setEmailId(email);
      const token = await execute();
      const data = {
        reCaptchaToken: token,
        email: email,
      };

      var response = await checkIsRegisteredEmail(data);
      if (!response.status) {
        setPageType(RegistrationComponentLoad.IDPNotExists);
      } else {
        TrackAnalytics(
          "/Registration",
          "IDP Exists - Matching Account Found",
          "Email matching"
        );
        if(response.isWandaUser){
          setWandaEmailId(email);
          setPageType(RegistrationComponentLoad.SingleWandaEmailValidation);
        }else{
          setIsIDPExists(true);
        }
      }
    } else {
      setIsValidEmail(false);
    }
  }

  function handleIsIDPExistsSuccess() {
    setIsIDPExists(false);
    window.location.hash = `/`; //Link to CCP login page
    window.location.reload();
  }
  function handleIsIDPExistsCancel() {
    setIsIDPExists(false);
    setBtnClick(false);
  }

  const handleBack = () => setPageType(RegistrationComponentLoad.ZipCode);

  return (
    <>
      <Row gutter={[0, 21]}>
        <Col xs={2} lg={4} />
        <Col>
          <Button
            link={true}
            clickHandler={handleBack}
            className={Styles.backBtn}
          >
            <div>
              <img src={backArrowIcon} alt="navigate-back" />
              Back
            </div>
          </Button>
        </Col>
        <Col xs={0} lg={24} />
      </Row>
      <Row id={Styles.emailPosition}>
        <Col span={2} />
        <Col span={24} lg={10} className={Styles.emailImage}>
          <img
            src={NiceToMeetYou}
            alt="NiceToMeetYou"
            className={Styles.emailImageWidth}
          />
        </Col>
        <Col span={2} />
        <Col span={24} lg={10} className={Styles.emailDiv}>
          <div className={Styles.zipData}>
            <div className={"subTextFont " + Styles.zipDataFont}>
              <img src={CheckMark_Blue} alt="checkMark" /> Great! Looks like we
              service your area:
            </div>
            <div className={"subTextFont " + Styles.zipDataBoldFont}>
              {zipData.city}, {zipData.state}, {zipData.zipcode.toString().padStart(5, '0')}
            </div>
            <div className={"subTextFont " + Styles.zipDataFont}>
              Next, let’s get your Caregiver account set up.
            </div>
          </div>
          <div className={Styles.emailMargin}>
            <ReCaptcha>
              {(captcha) => (
                <Form
                  form={form}
                  onFinish={(e) => handleEmail(captcha.execute)}
                  labelCol={{ span: 24 }}
                >
                  <Form.Item name="email" label="What's your email address?">
                    <Input
                      type="Text"
                      placeholder="Email Address"
                      onChange={handleEmailChange}
                      value={email}
                      className="subTextFont"
                    />
                    {!isValidEmail && (
                      <div>
                        <span className="subTextFont">
                          Please enter a valid email address.
                        </span>
                      </div>
                    )}
                  </Form.Item>

                  <Col span={24}>
                    <Button
                      type="submit"
                      // clickHandler={(e) => handleEmail(captcha.execute)}
                      disabled={
                        email.length === 0 || btnClick || !captcha.isReady
                      }
                      className={
                        email.length === 0 || !captcha.isReady
                          ? "wandaBtnDisabled"
                          : "wandaBtnEnabled"
                      }
                    >
                      Continue
                    </Button>
                  </Col>
                </Form>
              )}
            </ReCaptcha>
          </div>
        </Col>
        <div>
          <MTMAccountExistsModal
            isAccountFound={isIDPExists}
            handleWandaLogin={handleIsIDPExistsSuccess}
            handleAccountFoundCancel={handleIsIDPExistsCancel}
          />
        </div>
      </Row>
    </>
  );
};
export default Email;
